import { render, staticRenderFns } from "./saAsideNavHeader.vue?vue&type=template&id=408f12dc&functional=true"
import script from "./saAsideNavHeader.vue?vue&type=script&lang=js"
export * from "./saAsideNavHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports